module.exports = __webpack_public_path__ + "static/media/7.3.6792f1f2.png";